// @flow

export const ADD_ERROR = 'add_error';
export const REMOVE_ERROR = 'remove_error';
